<template>
    <div class="Mgj">
        <div class="m-header">
            <div class="top">
                <div class="userInfo">
                    <div class="headerImage">
                        <img class="userImg" v-lazy="user.isLogin? user.logourl:imgHeaderImg" alt="">
                    </div>
                    <div class="tip" v-if="!user.isLogin">登录后查看更多内容</div>
                    <div class="name" v-else>{{user.nickname}}</div>
                </div>
                <router-link :to="{name: 'MLogin'}" class="loginBtn" v-if="!user.isLogin">登录/注册</router-link>
            </div>
        </div>
        <div class="m-body">
            <div class="box" @click="gotoCompValue">
                <div class="left">
                    <img :src="require('@/common/images/gujingimgs/my/myIcon1.png')" alt="">
                    <span>我的企业估值</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <div class="box" @click="gotoEquity">
                <div class="left">
                    <img :src="require('@/common/images/gujingimgs/my/myIcon2.png')" alt="">
                    <span>我的股权激励</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
            <div class="box" @click="gotoUserInfo">
                <div class="left">
                    <img :src="require('@/common/images/gujingimgs/my/myIcon3.png')" alt="">
                    <span>个人信息</span>
                </div>
                <div class="right">
                    <div class="icon icon-arrow-right"></div>
                </div>
            </div>
        </div>
        <div class="returnHome" @click="goHome">
            <img :src="require('@/common/images/gujingimgs/my/my_goHome.png')" alt="">
        </div>
        <div class="logout" v-if="user.isLogin" @click="logout">注销账号</div>
    </div>
</template>

<script>
    import {getUserCustomerInfo} from 'api/systemApi'
    import {mapActions, mapGetters} from 'vuex'
    export default {
        name: 'My',
        metaInfo: {
            title: '个人中心'
        },
        data() {
            return {
                init: false,
                item: {
                    callbalance: '0',
                    desp:'',
                    qq:'',
                    headimgattid:'',
                    sextext:'',
                    wxno:'',
                    sex:99,
                    headimgurl:'',
                    nickname:'',
                    name:'',
                    mobileno:'',
                    email:''
                },
                imgHeaderImg: require('@/common/images/mmy/img-headerImg.png')
            }
        },
        mounted() {},
        activated() {
            if (this.user.isLogin && !this.init) {
                this.getView()
            }
        },
        methods: {
            gotoCompValue() {
                this.$router.push({name: 'CompValue'})
                this.setRefresh(true)
            },
            gotoEquity(){
                this.setRefresh(true)
                this.$router.push({name: 'Equity'})
            },
            gotoUserInfo() {
                this.setRefresh(true)
                this.$router.push({name: 'UserInfo'})
            },
            logout() {
                this.$dialog.confirm({
                    title: '',
                    message: '确认注销账号吗？',
                    confirmButtonColor: '#409EFF'
                }).then(() => {
                    this._logout()
                }).catch(() => {})
            },
            _logout() {
                let user = {
                    innerid: '',
                    loginToken: '',
                    loginname: '',
                    logourl: '',
                    mobile: '',
                    name: '',
                    nickname: '',
                    isLogin: false,
                    zjmemtype: 0
                }
                this.item.callbalance = '0'
                this.setUser(user)
                sessionStorage.setItem('user', JSON.stringify(user))
            },
            getView() {
                this.setLoading(true)
                getUserCustomerInfo({
                    data: {},
                    success: data => {
                        this.setLoading(false)
                        this.init = true
                        this.item = data.data
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$toast.fail(data.msg)
                    }
                })
            },
            // 回到首页
            goHome(){
                this.$router.push({name: 'GJMIndex'})
            },
            ...mapActions(['setLoading', 'setUser', 'setRefresh'])
        },
        filters: {},
        watch: {
        },
        computed: {
            ...mapGetters(['user'])
        },
        components: {
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";
    .Mgj {
        position: relative;
        padding-bottom: 0.88rem;
        .m-header{
            padding: 0.4rem 0.32rem;
            background: $c-white;
        }
        .top{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .userInfo{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .headerImage{
                    width: 1.1rem;
                    height: 1.1rem;
                    margin-right: 0.38rem;
                    margin-left: 0.16rem;
                    .userImg{
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                    }
                }
                .tip{
                    color: $c-grey;
                    font-size: 0.28rem;
                }
                .name{
                    font-size: 0.36rem;
                    color: $c-black;
                }
            }
            .loginBtn{
                width: 1.4rem;
                height: 0.48rem;
                line-height: 0.48rem;
                text-align: center;
                font-size: 0.24rem;
                color: $c-blue;
                border: 0.02rem solid $c-blue;
                border-radius: 0.24rem;
            }

        }
        .m-body{
            margin-top: 0.2rem;
            background: $c-white;
            padding: 0 0.32rem;
            color: $c-black;
            font-size: 0.3rem;
            .box{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 1.1rem;
                box-sizing: border-box;
                .left{
                    display: flex;
                    align-items: center;
                    img{
                        width: 0.36rem;
                        height: 0.36rem;
                        margin-right: 0.1rem;
                    }
                }
                .right{
                    .icon{
                        width: 0.15rem;
                        height: 0.25rem;
                    }
                }

            }
            .box+.box{
                border-top: 0.01rem solid $line;
            }
        }
        /*返回首页*/
        .returnHome{
            position: fixed;
            bottom: 0.62rem;
            right: 0;
            img{
                width: 1.82rem;
                height: 0.92rem;
            }
        }
        .logout{
            margin-top: 0.48rem;
            height: 1.1rem;
            font-size: 0.3rem;
            color: $c-red;
            line-height: 1.1rem;
            text-align: center;
            background: $c-white;
        }
    }
</style>